/*
 * Password forgotten
 */

//
//	Requirements
//

import React, {useState} from 'react';
import {createRoot} from 'react-dom/client';
import Button from '@mui/material/Button';
import {ThemeWrapper} from '@alias_root/src/components_react/theme';
import {InputEmail} from '@alias_root/src/components_react/Options';
import {TC} from './text';

//
// Types
//

type StylesType = {
	form: React.CSSProperties;
	button: React.CSSProperties;
};

//
// Constants
//

const styles: StylesType = {
	form: {
		outline: 0,
		minWidth: 200,
	},
	button: {
		display: 'none',
	},
};

//
// Types
//

type PropsType = {
	readonly data: {
		email: string;
	};
};

//
//	Export
//

function Form(props: PropsType): React.ReactNode {
	const [email, setEmail] = useState<string>('');

	const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();

		props.data.email = email;
	};

	const buttonRef = React.useRef<HTMLButtonElement>(null);

	return (
		<form style={styles.form} onSubmit={handleSubmit}>
			<InputEmail
				autoFocus
				maxLength="60"
				name="email"
				label={TC.labelEmail}
				value={email}
				onChange={(val: string) => setEmail(val)}
				onBlur={() => {
					(buttonRef.current as HTMLButtonElement).click();
				}}
			/>

			<Button style={styles.button} ref={buttonRef} type="submit" variant="outlined" color="primary">
				save
			</Button>
		</form>
	);
}

/*
 * render the form
 */
export function renderForm(container: Element | null, data: PropsType['data']): void {
	if (!container) {
		return;
	}
	createRoot(container).render(
		<ThemeWrapper>
			<Form data={data} />
		</ThemeWrapper>,
	);
}
